import './assets/css/App.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import AuthLayout from './layouts/auth';
import {
  ChakraProvider,
} from '@chakra-ui/react';
import initialTheme from './theme/theme';
import { useState } from 'react';
import { Toaster } from 'react-hot-toast';
import { UserProfileProvider } from 'contexts/UserProfileContext';
import AdminWrapper from 'components/AdminWrapper';
import NotFoundPage from 'views/404/NotFoundPage';
import ProtectedRoute from 'components/ProtectedRoute';
import AppRedirectScreen from 'views/auth/app-redirect/AppRedirectScreen';

export default function Main() {
  const [currentTheme, setCurrentTheme] = useState(initialTheme);

  return (
    <ChakraProvider theme={currentTheme}>
      <Toaster
        position="top-right"
        toastOptions={{
          className: '',
          style: {
            color: '#7a7a71',
            fontWeight: '500',
          },
        }}
      />

      <UserProfileProvider>
        <Routes>

          {/* <Route path="/auth/select-app" element={<AppRedirectScreen />} /> */}


          <Route path="auth/*" element={<AuthLayout />} />
          {/* <Route
            path="admin/*"
            element={<AdminWrapper theme={currentTheme} setTheme={setCurrentTheme} />}
          /> */}
          <Route
            path="admin/*"
            element={
              <ProtectedRoute>
                <AdminWrapper theme={currentTheme} setTheme={setCurrentTheme} />
              </ProtectedRoute>
            }
          />

          <Route path="/" element={<Navigate to="/auth/sign-in" replace />} />
          <Route path="*" element={<NotFoundPage />} />
          {/* <Route path="*" element={<Navigate to="/auth/sign-in" replace />} /> */}
        </Routes>
      </UserProfileProvider>
    </ChakraProvider>
  );
}
